module.exports = __webpack_public_path__ + "static/media/031.66b0ca41.jpg";